import React, { useMemo, useState } from "react";
import ISPV from "@market/components/SPVsList/ISPV";

import { Table } from "antd";
import { getSpvColumns } from "./const";
import { useSecondaryMarket } from "../../SecondaryMarket.context";
import { useMediaQuery } from "react-responsive";
import { DESKTOP_WIDTH } from "@bundles/consts";
import { SPVMobileExpandedRow } from "./SpvMobileExpandedRow";

type SPVsListProps = {
  spvsList: ISPV[];
};

export const SPVsList = ({ spvsList }: SPVsListProps) => {
  const isMobile = useMediaQuery({ maxWidth: DESKTOP_WIDTH });
  const { userSignedIn } = useSecondaryMarket();

  const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);

  const handleExpandToggle = (record: ISPV) => {
    setExpandedRowKeys((prev) =>
      prev.includes(record.id)
        ? prev.filter((id) => id !== record.id)
        : [...prev, record.id]
    );
  };

  const spvColumns = useMemo(
    () =>
      getSpvColumns({
        userSignedIn,
        isMobile,
        handleExpandToggle,
        expandedRowKeys,
      }),
    [userSignedIn, isMobile, handleExpandToggle, expandedRowKeys]
  );

  return (
    <div className="mt-[20px] md:mt-[30px]">
      <Table
        className="tailwind-table-white"
        columns={spvColumns}
        dataSource={spvsList}
        pagination={false}
        rowKey="id"
        expandable={
          isMobile
            ? {
                expandedRowKeys,
                defaultExpandAllRows: false,
                showExpandColumn: false,
                expandedRowClassName: () => "bg-grey-light",
                expandedRowRender: (record) => (
                  <SPVMobileExpandedRow
                    userSignedIn={userSignedIn}
                    spv={record}
                  />
                ),
              }
            : undefined
        }
      />
    </div>
  );
};
